<template>
  <el-dialog :close-on-click-modal="false" :visible="visible"
             :modal-append-to-body='false' @close="close">
    <el-tabs v-model="viewName">
      <el-tab-pane label="详情" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="预约名称：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.appointName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间：" :label-width="formLabelWidth">
                  <label v-text="detailForm.createTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营商ID：" :label-width="formLabelWidth">
                  <label v-text="detailForm.operatorId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="站点：" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="站点ID：" :label-width="formLabelWidth">
                  <label v-text="detailForm.stationId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生效时间：" :label-width="formLabelWidth">
                  <label v-text="detailForm.beginTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="失效时间：" :label-width="formLabelWidth">
                  <label v-text="detailForm.endTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="可预约充电枪" name="gunsformation">
              <el-col :span="24">
                <el-form-item label="可预约充电枪：" :label-width="formLabelWidth" prop="gunCode">
                  <el-tree
                    ref="tree"
                    :data="gunTree"
                    :filter-node-method="filterNode"
                    @node-expand="handleNodeExpand">
                  </el-tree>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="预约信息" name="moreInformation">
              <el-col :span="12">
                <el-form-item label="预约阈值：" :label-width="formLabelWidth">
                  <label v-text="detailForm.targetIntegral + ' 积分'"></label>
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">
                <el-form-item label="移动端显示可预约：" :label-width="formLabelWidth">
                  <el-switch
                    v-model="detailForm.showAppointCode"
                    active-value="Y"
                    inactive-value="N"
                    disabled></el-switch>
                </el-form-item>
              </el-col>-->
              <el-col :span="12">
                <el-form-item label="预约提前时间量：" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointTimes + ' 分'"></label>
                </el-form-item>
              </el-col>

              <el-col  :span="12">
                <el-form-item label="预约是否消耗积分：" :label-width="formLabelWidth">
                  <label v-if="detailForm.appointIsDeduct === 'Y'" v-text="'是'"></label>
                  <label v-if="detailForm.appointIsDeduct === 'N'" v-text="'否'"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.appointIsDeduct === 'Y'" :span="12">
                <el-form-item label="预约消耗积分：" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointDeductIntegral + ' 积分'"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.maxNum > 0" :span="12">
                <el-form-item   label="最大失约次数：" :label-width="formLabelWidth">
                  <label  v-text="detailForm.maxNum + ' 次'"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.maxNum === 0" :span="12">
                <el-form-item   label="最大失约次数：" :label-width="formLabelWidth">
                  <label  v-text="'不限制'"></label>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="失约扣分：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.deductIntegral + ' 积分'"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="timeSlots != ''" :span="24">
                <el-form-item label="可预约时间段：" :label-width="formLabelWidth">
                  <el-tag :style="{marginRight: '6px'}" :key="index" v-for="(item, index) in timeSlots">
                    {{item}}
                  </el-tag>
                </el-form-item>
              </el-col>

              <el-col v-if="timeSlots === ''" :span="24">
                <el-form-item label="可预约时间段：" :label-width="formLabelWidth">
                  <el-tag :style="{marginRight: '6px'}" >
                    24h生效
                  </el-tag>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="预约描述：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.desc"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
    export default {
        name: "detail",
      props: {
        visible: false,
        detailForm: {},
        gunTree: {
          type: Array,
          required: true
        },
      },
      data() {
        return {
          viewName: 'detailForm',
          activeNames: ['basicInformation', 'moreInformation'],
          formLabelWidth: '150px',
        }
      },
      computed: {
        timeSlots() {
          if(this.detailForm.timeSlots) {
            return this.detailForm.timeSlots.split(',')
          }else {
            return ''
          }
        }
      },
      methods: {
        handleNodeExpand(data, node) {
          if(node.level === 1) this.$refs.tree.filter()
        },
        filterNode(value, data, node) {
          return this.detailForm.appointConfGuns.some((item, i) => {
            return item.gunCode === data.id
          })
        },
        close() {
          this.$emit('close', 'detail')
        }
      },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/detail.vue